import { useRef, ChangeEvent, Fragment } from 'react';
import { Button } from 'antd';

type Props = {
  label: string;
  uploadFileName: string;
  onChange: (formData: FormData) => void;
  acceptedFileTypes?: string;
  allowMultipleFiles?: boolean;
};

const FileInputButton: React.FC<Props> = ({
  label,
  uploadFileName,
  onChange,
  acceptedFileTypes,
  allowMultipleFiles,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const onClick = () => {
    fileInputRef.current?.click();
  };

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files?.length) {
      return;
    }

    const formData = new FormData();

    Array.from(event.target.files).forEach((file) => {
      formData.append(event.target.name, file);
    });

    onChange(formData);
  };

  return (
    <Fragment>
      <Button type="default" htmlType="button" onClick={onClick}>
        {label}
      </Button>
      <input
        accept={acceptedFileTypes}
        multiple={allowMultipleFiles}
        name={uploadFileName}
        onChange={handleOnChange}
        ref={fileInputRef}
        style={{ display: 'none' }}
        type="file"
      />
    </Fragment>
  );
};

export default FileInputButton;
